import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { IonAccordionGroup, ModalController } from "@ionic/angular";
import { ProductDetailsModalComponent } from "../../../../components/product-details-modal/product-details-modal.component";
import { GoogleMap, Marker } from "@capacitor/google-maps";
import {appUrl} from "../../../../../../../../common/runtime-config";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { HttpEventType } from "@angular/common/http";
import {DomSanitizer} from '@angular/platform-browser';
import { isEmbeddableHttpUrl } from '../../../../../../../../common/passport/video-embed.util'

@Component({
  selector: "app-product-timeline-item",
  templateUrl: "./product-timeline-item.component.html",
  styleUrls: ["./product-timeline-item.component.scss"],
})
export class ProductTimelineItemComponent implements OnInit {
  @Input("steps") steps: any;
  @Input("product") product: any;
  @ViewChild("accordionGroup") accordionGroup: any;
  @ViewChildren('mapContainer') mapContainers: QueryList<ElementRef>;
  mapContainersArray: ElementRef[];

  map: GoogleMap;

  stepImage: string;
  companyImage: string = "";
  companyName: string;
  // New grouped timeline structure (section -> facility -> batch)
  groupedTimeline: any[] = [];

  // Track collapsed state of batches per facility (keyed by section-facility index)
  private facilityCollapseState: { [key: string]: boolean } = {};

  constructor(private modalCtrl: ModalController,private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.buildGroupedTimeline();
  }
  ngAfterViewInit() {
    this.mapContainersArray = this.mapContainers.toArray();

  }



  getMarker(step): Marker {
    const lati = parseFloat(step.facility.latitude);
    const longi = parseFloat(step.facility.longitude);

    return {
        coordinate: {
            lat: lati,
            lng: longi
        },
        title: step.facility.name,
        snippet: step.facility.address
    }
}
  toggleAccordion = (sectionIndex: number, facilityIndex: number, batchIndex: number, step: any, event: any) => {
    //this.showDetails(step)

    const seeMoreBtnTitle = event.target.querySelector(".see-more-text")
      ? event.target.querySelector(".see-more-text")
      : event.target;
    const nativeEl = document.getElementById(
      "stepMoreDetails" + sectionIndex + "_" + facilityIndex + "_" + batchIndex
    );
    if (nativeEl.classList.contains("hide")) {
      nativeEl.classList.remove("hide");
      seeMoreBtnTitle.innerText = "Ver menos";
    } else {
      nativeEl.classList.add("hide");

      seeMoreBtnTitle.innerText = "Ver más";
    }
  };

  getStepImage(path: string) {
    this.companyImage = `${appUrl()}/images/${this.product.company.id}/${this.product.company.logo?.path}`;
    this.companyName = this.product.company.name;
    if (path) {
      this.stepImage = `${appUrl()}/images/${this.product.company.id}/${path}`;
    } else {
      this.stepImage = this.companyImage;
    }
    return this.stepImage;
  }

  async showDetails(item: any) {
    const modal = await this.modalCtrl.create({
      component: ProductDetailsModalComponent,
      breakpoints: [0, 1],
      initialBreakpoint: 0.7,
      handle: false,
      componentProps: { item },
    });

    await modal.present();
  }

  downloadImage(path: string, companyId: string, name: string) {
    const imagePath: string = `/images/${companyId}/${path}`;
    const url = imagePath;
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name}`;
    link.click();
    URL.revokeObjectURL(url);
}



downloadDocument(path: string, companyId: string, name: string) {
    const documentPath: string = `/documents/${companyId}/${path}`;
    const url = documentPath;
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name}`;
    link.click();
    URL.revokeObjectURL(url);
}

getImageCompany(step) {
  if (!step) {
    return '';
  }
  // Verificar si step tiene companyImage directamente
  if (step.companyImage && step.companyImage.path && step.companyImage.path !== '' && step.companyImage.path !== 'null') {
    return `${appUrl()}/images/${this.product.company.id}/${step.companyImage.path}`;
  }
  
  // Si no hay imagen, devolver cadena vacía (no mostrar imagen)
  return '';
}

getTextCompany(step) {
  if (step.companyImage.length > 0 && step.companyImage.text != '' && step.companyImage.text != 'null') {
      return `${step.companyImage.text}`
  } else {
      return ''
  }
}

getVideoCompany(step) {
  if (step.companyImage && step.companyImage.videoLink != '' && step.companyImage.videoLink != 'null') {
      return this.setVideoLink(step.companyImage.videoLink)
  } else {
      return ''
  }
}

setVideoLink(link: string) {
  let videoEmbedUrl = '';
  const videoUrl = link;
  const youtubeRegex = /^(https?\:\/\/)?(www\.)?(youtube|youtu|youtube-nocookie)\.(com|be)\/(watch\?v=|embed\/|v\/)?([a-zA-Z0-9_-]{11})/;
  const vimeoRegex = /^(https?\:\/\/)?(www\.)?(vimeo)\.com\/(\d+)($|\/)/;
  const dailymotionRegex = /^(https?\:\/\/)?(www\.)?(dailymotion)\.com\/video\/(\w+)(.*)/;
  const directVideoRegex = /\.(mp4|ogg|webm)$/i;

  if (isEmbeddableHttpUrl(videoUrl)) {
      if (videoUrl.match(youtubeRegex)) {
          const youtubeMatch = videoUrl.match(youtubeRegex);
          if (youtubeMatch) {
              videoEmbedUrl = `https://www.youtube.com/embed/${youtubeMatch[6]}`;
          }
      } else if (videoUrl.match(vimeoRegex)) {
          videoEmbedUrl = videoUrl.replace(vimeoRegex, 'https://player.vimeo.com/video/$4');
      } else if (videoUrl.match(dailymotionRegex)) {
          videoEmbedUrl = videoUrl.replace(dailymotionRegex, 'https://www.dailymotion.com/embed/video/$4');
      } else if (videoUrl.match(directVideoRegex)) {
          videoEmbedUrl = videoUrl;
      }
  }
  // videoEmbedUrl is only non-empty inside the isEmbeddableHttpUrl branch above,
  // so only an http(s) link reaches the bypass. The bypass itself cannot go away:
  // Angular blocks every resource URL in an <iframe src> without it.
  // nosemgrep: typescript.angular.security.audit.angular-domsanitizer.angular-bypasssecuritytrust
  return videoEmbedUrl ? this.sanitizer.bypassSecurityTrustResourceUrl(videoEmbedUrl) : videoEmbedUrl
}

formatFieldText(text: string): string {
  if (!text) return '';
  const textWithSpaces = text.replace(/_/g, ' ');
  return textWithSpaces.charAt(0).toUpperCase() + textWithSpaces.slice(1);
}

getSortedFields(fields: any[]): any[] {
  if (!fields || !Array.isArray(fields)) {
    return [];
  }
  
  // Create a copy to avoid mutating the original array
  const sortedFields = [...fields];
  
  // Sort by order property if it exists, otherwise sort alphabetically by description
  return sortedFields.sort((a, b) => {
    // If both have order property, sort by order
    if (a.order !== undefined && b.order !== undefined) {
      return a.order - b.order;
    }
    // If only a has order, it comes first
    if (a.order !== undefined) {
      return -1;
    }
    // If only b has order, it comes first
    if (b.order !== undefined) {
      return 1;
    }
    // Otherwise, sort alphabetically by description
    const descA = (a.description || '').toLowerCase();
    const descB = (b.description || '').toLowerCase();
    return descA.localeCompare(descB);
  });
}

  /**
   * Build a grouped timeline structure from the flat `steps` input.
   * Grouping:
   *  - First by step title (Packaging, Slicing, Fattening, etc.)
   *  - Inside each step, by facility
   *  - Inside each facility, by batchIn/batchOut pairs
   */
  private buildGroupedTimeline() {
    if (!this.steps || !Array.isArray(this.steps)) {
      this.groupedTimeline = [];
      return;
    }

    const sectionsMap: { [title: string]: any } = {};

    this.steps.forEach((step: any) => {
      // `step?.title` on the line below already admits a null entry, and the three reads that
      // followed did not: one null inside `steps` threw and took the WHOLE timeline with it.
      // `step-map-details` hands over `[steps]="[step]"` — an array built around a possibly
      // absent step — so opening that modal before the step arrived did exactly that.
      const sectionTitle = step?.title || 'Unknown step';
      if (!sectionsMap[sectionTitle]) {
        sectionsMap[sectionTitle] = {
          title: sectionTitle,
          activities: step?.activities || [],
          isPublic: step?.isPublic ?? step?._public ?? true,
          facilities: []
        };
      }

      const section = sectionsMap[sectionTitle];
      const activities = step?.activities || [];

      activities.forEach((activity: any) => {
        if (!activity || !activity.facility) {
          return;
        }

        const facilityId = activity.facility.id;
        let facilityGroup = section.facilities.find((f: any) => f.facility.id === facilityId);
        if (!facilityGroup) {
          facilityGroup = {
            facility: activity.facility,
            batches: []
          };
          section.facilities.push(facilityGroup);
        }

        const batchIns = activity.batchIn || [];
        const batchOuts = activity.batchOut || [];

        // If there are no batches, still create a single logical "batch" entry from the activity
        if (batchIns.length === 0 && batchOuts.length === 0) {
          facilityGroup.batches.push({
            batchIn: null,
            batchOut: null,
            activity
          });
        } else {
          // Pair each batchIn with each batchOut (cartesian) – this keeps things explicit for the UI
          if (batchIns.length === 0) {
            batchOuts.forEach((bo: any) => {
              facilityGroup.batches.push({
                batchIn: null,
                batchOut: bo,
                activity
              });
            });
          } else if (batchOuts.length === 0) {
            batchIns.forEach((bi: any) => {
              facilityGroup.batches.push({
                batchIn: bi,
                batchOut: null,
                activity
              });
            });
          } else {
            batchIns.forEach((bi: any) => {
              batchOuts.forEach((bo: any) => {
                facilityGroup.batches.push({
                  batchIn: bi,
                  batchOut: bo,
                  activity
                });
              });
            });
          }
        }
      });
    });

    this.groupedTimeline = Object.values(sectionsMap);
  }

  private getFacilityKey(sectionIndex: number, facilityIndex: number): string {
    return `${sectionIndex}-${facilityIndex}`;
  }

  toggleFacility(sectionIndex: number, facilityIndex: number): void {
    const key = this.getFacilityKey(sectionIndex, facilityIndex);
    this.facilityCollapseState[key] = !this.facilityCollapseState[key];
  }

  isFacilityCollapsed(sectionIndex: number, facilityIndex: number): boolean {
    const key = this.getFacilityKey(sectionIndex, facilityIndex);
    // default to true (collapsed) if not set
    return this.facilityCollapseState[key] !== false;
  }
}
